import Link from "next/link";

import type { VariantPage } from "@/lib/api/formatting/rorosTweed/productPage";

import styles from "./variants.module.scss";

type VariantsUI = {
  variants: NonNullable<
    NonNullable<VariantPage["info"]>["details"]
  >["variants"];
  variantName: string | undefined;
  sku: string | undefined;
};

const UI = (props: VariantsUI) => {
  const variants = props.variants;
  const variantName = props.variantName;
  const sku = props.sku;
  return (
    <div className={styles.container}>
      <div className={styles.variantsContainer}>
        {variants?.map((variant) => (
          <button
            aria-label={`${variant.colourName}`}
            className={`${styles.variantContainer} ${
              variant.active ? styles.active : ""
            }`}
            key={`variant-swatch-link-${variant.uri}`}
            onClick={variant.setActive}
          >
            <Link href={variant.uri} legacyBehavior>
              <div
                style={
                  variant.colourCode
                    ? { backgroundColor: variant.colourCode }
                    : {}
                }
                className={styles.variantSwatch}
              />
            </Link>
          </button>
        ))}
      </div>
      <div className={styles.variantDetails}>
        <p className={styles.sku}>{sku}</p>
        <p className={styles.variantName}>{variantName}</p>
      </div>
    </div>
  );
};

export default UI;
